export function numberFormatToRub(amount: number) {
  if (isNaN(amount)) return;

  const isNegative = amount < 0;
  const absoluteAmount = Math.abs(amount / 100);

  const fixedAmount = Number(absoluteAmount).toFixed(2);

  const [integerPart, decimalPart] = fixedAmount.split('.');

  const formattedIntegerPart = integerPart
    .split('')
    .reverse()
    .join('')
    .match(/.{1,3}/g)
    ?.join(' ')
    .split('')
    .reverse()
    .join('');

  if (formattedIntegerPart) {
    return `${isNegative ? '-' : ''}${formattedIntegerPart}.${decimalPart} руб`;
  }

  return undefined;
}
